import { AlertTriangle } from "lucide-react";
import { Button } from "@sonify/web-ui";

export interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message = "Something went wrong", onRetry }: ErrorStateProps) {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="bg-surface-elevated border border-error-border rounded-xl p-8 max-w-md w-full flex flex-col items-center gap-4 text-center shadow-lg">
        <div className="h-12 w-12 rounded-full bg-error-background flex items-center justify-center">
          <AlertTriangle className="h-6 w-6 text-error-text" />
        </div>
        <div className="flex flex-col gap-1">
          <h3 className="text-sm font-semibold text-foreground">Something went wrong</h3>
          <p className="text-xs text-foreground-muted font-mono break-all">{message}</p>
        </div>
        {onRetry && (
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Try again
          </Button>
        )}
      </div>
    </div>
  );
}
